<template>
  <div class="container">
    <div class="accounts">
      <p class="accounts__header">
        {{ $t('cookie.listCookies', { count: inputAccs }) }}
      </p>

      <textarea
        v-model="listAccs"
        ref="inputAccs"
        :readonly="waitResponse"
        id="inputAccs"
        spellcheck="false"
      ></textarea>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        "
      >
        <button
          class="btn btn__check unselect ld-ext-right"
          ref="checkAccounts"
          @click="checkAccount"
          :class="{
            loading: waitResponse,
            running: waitResponse,
          }"
          :disabled="!listAccs.length || waitResponse"
        >
          {{ $t('global.check') }}
          <div class="ld ld-ring ld-spin-fast"></div>
        </button>
        <button
          @click="clearListAccs"
          :disabled="waitResponse"
          class="btn btn__clear unselect"
        >
          {{ $t('global.clear') }}
        </button>
        <!-- <button class="btn btn__test unselect">Тест</button>

        <label class="check-friends unselect"
          >Проверить кол-во друзей
          <input type="checkbox" v-model="checkFriends" />
          <span class="checkmark"></span>
        </label> -->
      </div>
    </div>

    <div class="result">
      <p class="result__header">
        {{
          $t('global.checkResult', {
            percent: task.percent,
            time: formatCheckedTime,
          })
        }}
      </p>

      <DynamicScroller
        :items="task.data"
        :min-item-size="22"
        @scroll.self="syncIO"
        ref="scroller"
        class="textarea"
        style="padding: 10px 0"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.account]"
            :data-index="index"
          >
            <div class="res">
              <span class="line unselect">{{ index + 1 }}.</span>
              <span style="align-items: center; display: flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  style="fill: steelblue"
                >
                  <path
                    d="M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.938.005-.034.016-.134.017-.168a.998.998 0 0 0-1.254-1.006A3.002 3.002 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-2 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.5-6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                  ></path>
                </svg>
              </span>
              →
              <span
                :class="{
                  valid: item.status.name === 'valid',
                  invalid: item.status.name === 'invalid',
                  nonexistent: item.status.name === 'noexist',
                }"
                >{{ item.status.message }}
              </span>

              <span style="align-items: center; display: flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  style="fill: steelblue; margin: 0px 4px 0px 0px"
                >
                  <path
                    d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                  ></path>
                </svg>
                <a
                  :href="item.profileLink"
                  :class="{ 'crossed-text': item.status.name === 'noexist' }"
                  target="_blank"
                  >{{ item.uid }}</a
                >
              </span>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>

      <!-- <div
        @scroll="syncIO"
        ref="results"
        class="textarea"
        spellcheck="false"
        style="padding: 10px 0 10px 0"
      >
        <div v-if="task.data.length">
          <div class="res" v-for="(item, index) in task.data" :key="item.id">
            <span class="line unselect">{{ index + 1 }}.</span>
            <span style="align-items: center; display: flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                style="fill: steelblue"
              >
                <path
                  d="M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.938.005-.034.016-.134.017-.168a.998.998 0 0 0-1.254-1.006A3.002 3.002 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-2 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.5-6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                ></path>
              </svg>
            </span>
            →
            <span
              :class="{
                valid: item.status.name === 'valid',
                invalid: item.status.name === 'invalid',
                nonexistent: item.status.name === 'noexist',
              }"
              >{{ item.status.message }}
            </span>

            <span style="align-items: center; display: flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                style="fill: steelblue; margin: 0px 4px 0px 0px"
              >
                <path
                  d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                ></path>
              </svg>
              <a
                :href="item.profileLink"
                :class="{ 'crossed-text': item.status.name === 'noexist' }"
                target="_blank"
                >{{ item.uid }}</a
              >
            </span>
          </div>
        </div>
      </div> -->

      <div
        v-if="task.data.length"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <div
          class="res-counts"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;
            justify-content: start;
          "
        >
          <div
            v-if="task.info.valid"
            v-tippy="{
              content: 'Скопировать валид',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать валид');
              },
            }"
            @click="copyResult($event, 'valid')"
            style="
              box-shadow: rgb(189 186 186) 0px 5px 20px -6px;
              border-radius: 5px;
              padding: 5px 10px;
              border: 2px solid grey;
              display: flex;
              align-items: center;
              gap: 5px;
              cursor: pointer;
            "
          >
            <div
              style="
                background: #147b02;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border: 2px solid #dcdcdc;
              "
            ></div>
            {{ task.info.valid }} • {{ statusPercent(task.info.valid) }}%
          </div>

          <div
            v-if="task.info.invalid"
            v-tippy="{
              content: 'Скопировать невалид',
              hideOnClick: false,
              theme: 'material',
              animation: 'shift-away',
              onHidden(instance) {
                instance.setContent('Скопировать невалид');
              },
            }"
            @click="copyResult($event, 'invalid')"
            style="
              box-shadow: rgb(189 186 186) 0px 5px 20px -6px;
              border-radius: 5px;
              padding: 5px 10px;
              border: 2px solid grey;
              display: flex;
              align-items: center;
              gap: 5px;
              cursor: pointer;
            "
          >
            <div
              style="
                background: #af0b0b;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border: 2px solid #dcdcdc;
              "
            ></div>
            {{ task.info.invalid }} • {{ statusPercent(task.info.invalid) }}%
          </div>
          <div
            v-if="task.info.noExist"
            style="
              box-shadow: rgb(189 186 186) 0px 5px 20px -6px;
              border-radius: 5px;
              padding: 5px 10px;
              border: 2px solid grey;
              display: flex;
              align-items: center;
              gap: 5px;
              cursor: pointer;
            "
          >
            <div
              style="
                background: #905509;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border: 2px solid #dcdcdc;
              "
            ></div>
            {{ task.info.noExist }} • {{ statusPercent(task.info.noExist) }}%
          </div>
        </div>

        <button
          v-if="!waitResponse"
          @click="exportCSV"
          :disabled="waitResponseCSV"
          :class="{
            loading: waitResponseCSV,
            running: waitResponseCSV,
          }"
          class="btn btn__export unselect ld-ext-right"
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style="fill: rgb(255 255 255); transform: ; msfilter: "
          >
            <path d="m12 16 4-5h-3V4h-2v7H8z"></path>
            <path
              d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
            ></path>
          </svg> -->

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style="fill: white; transform: ; msfilter: "
          >
            <path d="M11 16h2V7h3l-4-5-4 5h3z"></path>
            <path
              d="M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
            ></path>
          </svg>
          {{ $t('global.export') }}
          <div class="ld ld-ring ld-spin-fast"></div>
        </button>
      </div>
    </div>

    <a class="hide" ref="exportLink"></a>
  </div>

  <Modal ref="connectTg">
    <template #header> Подтвердите доступ </template>
    <template #body>
      <p>
        Чтобы использовать тариф Free, подключите в 2 клика наш
        <a href="https://t.me/checkerFBRIPbot" target="_blank">Telegram Bot</a>.
      </p>
      <p>
        Если у вас нет Telegram аккаунта, скачайте и установите мессенджер на
        <a href="https://telegram.org" target="_blank">официальном сайте</a>.
      </p>
      <p>
        Если хотите использовать платные тарифы от $5, которые не требуют
        подключения к боту, перейдите на
        <a href="" @click.prevent="this.$router.push('/pay')">страницу оплаты</a
        >.
      </p>
    </template>
  </Modal>
</template>

<script>
import moment from 'moment';
import Modal from '@/components/Modal.vue';
import { directive } from 'vue-tippy';

export default {
  components: {
    Modal,
  },

  directives: {
    tippy: directive,
  },
  data() {
    return {
      waitResponse: false,
      waitResponseCSV: false,
      listAccs: '',
      listAccsArray: [],
      task: {
        percent: 0,
        data: [],
        info: {},
      },
      checkFriends: false,
    };
  },

  computed: {
    inputAccs() {
      return this.listAccs.split('\n').filter((n) => n).length;
    },

    formatCheckedTime() {
      const time = this.task.info.checkedTime;

      if (time) {
        return moment
          .utc(moment.duration(time, 'seconds').asMilliseconds())
          .format('mm:ss');
      } else {
        return '00:00';
      }
    },
  },

  methods: {
    clearListAccs() {
      this.listAccs = '';
      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};
      // Очистка тем даты
      delete localStorage.cookiesData;

      this.$refs.inputAccs.focus();
    },

    // syncIO(e) {
    //   const eventTarget = e.target.id;
    //   const scrollTop = e.target.scrollTop;

    //   if (eventTarget === 'inputAccs') {
    //     this.$refs.results.scrollTop = scrollTop;
    //   } else {
    //     this.$refs.inputAccs.scrollTop = scrollTop;
    //   }
    // },

    syncIO({ target }) {
      const { scrollTop } = target;
      this.$refs.inputAccs.scrollTop = scrollTop;
    },

    filterAccounts(account) {
      // console.log(account);

      const re1 = /^\[\{.+\}\]$/gi;

      if (account.match(re1)) {
        return account;
      } else {
        return;
      }
    },

     makeid(length) {
      var result = '';
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    async checkAccount() {
      this.waitResponse = true;

      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};

      // Удаляем дубли, пробелы в списке акков, лишние символы в начале/конце строки и обновляем список
      const uidList = [
        ...new Set(
          this.listAccs
            .split('\n')
            .map((s) => s.trim())
            .filter((n) => this.filterAccounts(n))
        ),
      ];

      // const uidList = this.listAccs.split('\n');

      const requestId = this.makeid(16);
      this.listAccs = uidList.join('\n').trim();
      this.listAccsArray = uidList;

      // Разбиваем список аккаунтов на части
      const perChunk = 100;
      const uidListChunk = uidList.reduce(
        (chunks, el, i) =>
          (i % perChunk
            ? chunks[chunks.length - 1].push(el)
            : chunks.push([el])) && chunks,
        []
      );

      // console.log(uidList);
      // console.log(uidListChunk);

      // Отправляем запрос
      for (const list of uidListChunk.values()) {
        try {
          const response = await this.axios.post('check/cookies', {
            inputData: list,
            userLang: localStorage.userLang,
            requestId: requestId
          });

          if (response.data.error) {
            // throw new Error(response.data.error);
            if (response.data.error.code === 'noConnectTg') {
              this.$refs.connectTg.openModal();
            } else {
              this.showToaster(response.data.error.message);
            }

            break;
          }

          this.task.data.push(...response.data.data);

          if (!this.task.info) {
            this.task.info = response.data.info;
          } else {
            const sumValueByKey = (...rest) =>
              rest.reduce((result, current) => {
                for (const key in current) {
                  const value = current[key];

                  if (result[key] === undefined) {
                    result[key] = value;
                  } else {
                    result[key] += value;
                  }
                }

                return result;
              }, {});

            this.task.info = sumValueByKey(this.task.info, response.data.info);
          }

          // Вычисляем % выполнения задачи
          this.task.percent = Math.round(
            (this.task.data.length / uidList.length) * 100
          );
        } catch (err) {
          // alert(err.message);
          this.showToaster(err.message);
          break;
        }
      }

      // Подгружаем актуальные данные по пользователю
      // this.axios.get('user/me').then((resp) => {
      //   this.$store.state.user = resp.data.user;
      //   localStorage.userInfo = JSON.stringify(resp.data.user);
      // });

      // Сохраняем темп дату, если данных меньше 10к
      if (this.task.data.length <= 10000) {
        localStorage.cookiesData = JSON.stringify({
          in: this.listAccs,
          inArray: this.listAccsArray,
          out: this.task,
        });

        console.log('save cookies');
      }

      // Разблокировка кнопок и полей
      this.waitResponse = false;
    },

    statusPercent(count) {
      return Math.round((count / this.listAccsArray.length) * 100);
    },

    copyResult(event, status) {
      const cookies = {};
      if (status === 'valid' || status === 'invalid' || status === 'noexist') {
        cookies.data = this.task.data
          .filter((a) => a.status.name === status)
          .map((v) => v.cookie)
          .join('\n');
      }

      navigator.clipboard
        .writeText(cookies.data)
        .then(() => {
          console.log('copy');
          event.target._tippy.setContent('Скопировано');
          return true;
        })
        .catch(() => {
          console.log('error copy');
          event.target._tippy.setContent('Ошибка копирования');
          return false;
        });
    },

    async exportCSV() {
      this.waitResponseCSV = true;
      const exportDate = moment().format();

      const res = this.task.data;
      const rows = [['uid', 'status', 'profileLink', 'cookie']];

      for (const index in res) {
        rows.push([
          res[index].uid,
          res[index].status.name,
          res[index].profileLink,
          res[index].cookie,
        ]);
      }

      const csvContent = rows.map((e) => e.join('\t')).join('\n');

      const blob = new Blob([csvContent], { type: 'csv/plain' });
      const link = this.$refs.exportLink;
      link.href = window.URL.createObjectURL(blob);
      link.download = `export_cookies.${exportDate}(checker.fb.rip).csv`;
      link.click();
      this.waitResponseCSV = false;
    },

    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top',
        // duration: false,
      });
    },
  },

  mounted() {
    const cookiesData = localStorage.cookiesData;

    if (!cookiesData) {
      this.$refs.inputAccs.focus();
    }

    if (cookiesData && JSON.parse(cookiesData).in) {
      this.listAccs = JSON.parse(cookiesData).in;
      this.listAccsArray = JSON.parse(cookiesData).inArray;
    }

    if (cookiesData && JSON.parse(cookiesData).out) {
      this.outputData = JSON.parse(cookiesData).out;
      this.task = JSON.parse(cookiesData).out;
    }
  },
};
</script>

<style scoped>
.hide {
  display: none;
}

textarea {
  white-space: nowrap;
}

textarea:focus {
  white-space: unset;
}
</style>
